import { client } from "@/sanity/lib/client";
import { faqsQuery, faqsByCategoryQuery } from "@/sanity/lib/queries";
import { SanityFAQ } from "@/sanity/lib/types";

export async function getFAQs() {
  const faqs: SanityFAQ[] = await client.fetch(
    faqsQuery,
    {},
    {
      next: { 
        revalidate: 86400,
        tags: ['faqs']
      }
    }
  );
  return faqs;
}

export async function getFAQsByCategory(category: string) {
  const faqs: SanityFAQ[] = await client.fetch(
    faqsByCategoryQuery, 
    { category },
    {
      next: { 
        revalidate: 86400,
        tags: ['faqs', `faqs-${category}`]
      }
    }
  );
  return faqs;
}

export async function getFeaturedFAQs() {
  const faqs: SanityFAQ[] = await client.fetch(
    faqsQuery,
    {},
    {
      next: { 
        revalidate: 86400,
        tags: ['faqs']
      }
    }
  );
  return faqs.filter(faq => faq.featured);
}
